import {Button} from "@zendeskgarden/react-buttons";
import {ReactComponent as PencilIcon} from "@zendeskgarden/svg-icons/src/16/pencil-stroke.svg";
import {ReactElement} from "react";
import {PropertyExecutiveSummaryData} from "../logic/usePropertyExecutiveSummaryData";
import {
    buildExecutiveSummaryStatementNOI,
    buildExecutiveSummaryStatementRentalIncome,
    buildExecutiveSummaryStatementRents,
    buildExecutiveSummaryStatementTotalExpense,
    formatAsJSX
} from "../logic/summaryStringBuilders";
import css from "../styles/css.module.scss";
import MetricBlock from "./MetricBlock";


interface ExecutiveSummaryMetricBlockProps {
    data: PropertyExecutiveSummaryData | undefined;
    customNarrativeParagraphs: string[];
    narrativeLoading: boolean;
    onEditSummary?: () => void;
}

export default function ExecutiveSummaryMetricBlock(props: ExecutiveSummaryMetricBlockProps): ReactElement {
    let summaryText: ReactElement = <></>;

    if (props.customNarrativeParagraphs.length > 0) {
        summaryText = (
            <div>
                {props.customNarrativeParagraphs.map((paragraph, index) =>
                    <p key={index} className={css.narrativeParagraph}>{paragraph}</p>
                )}
            </div>
        );
    } else if (!props.narrativeLoading) {
        summaryText = (
            <div>
                {formatAsJSX(buildExecutiveSummaryStatementNOI(props.data))}
                {formatAsJSX(buildExecutiveSummaryStatementRents(props.data))}
                {formatAsJSX(buildExecutiveSummaryStatementRentalIncome(props.data))}
                {formatAsJSX(buildExecutiveSummaryStatementTotalExpense(props.data), false)}
            </div>
        );
    }

    return (
        <MetricBlock
            title="Executive Summary"
            text={summaryText}
            titleAction={props.onEditSummary &&
                <Button size="small" onClick={props.onEditSummary}>
                    <Button.StartIcon><PencilIcon /></Button.StartIcon>
                    Edit Summary
                </Button>
            }
        />
    );
}
